import { Stack } from "@mui/material";
import CustomAreaChart from "../../../components/charts/CustomAreaChart";
import CustomMultiLineChart from "../../../components/charts/CustomMultiLineChart";
import { multiAxisFormatter } from "../../../utils/chart";
import ChartRangeToggleGroup from "../../../components/charts/ChartRangeToggleGroup";


const MultiAxisAnalysisChart = ({ plottingDatasets, plottingRange, handlePlottingRangeChangeHandler, chartRangeToggleOptions, plottingType, handlePlottingTypeChangeHandler, chartTypeToggleOptions, chartRef }) => {

    const formattedPlottingData = multiAxisFormatter(plottingType, plottingDatasets)

    return (
        <Stack gap={2} sx={{ flex: 1 }}>
            <Stack direction="row" gap={{ xs: 4 }} alignItems="center" justifyContent="flex-end">
                <ChartRangeToggleGroup
                    value={plottingType}
                    changeHandler={handlePlottingTypeChangeHandler}
                    options={chartTypeToggleOptions}
                />
            </Stack>
            <Stack gap={4} alignItems="center">
                {formattedPlottingData.length > 1 ? <CustomMultiLineChart chartData={formattedPlottingData} chartRef={chartRef} /> : <CustomAreaChart chartData={formattedPlottingData[0]} chartRef={chartRef} />}
                <ChartRangeToggleGroup
                    value={plottingRange}
                    changeHandler={handlePlottingRangeChangeHandler}
                    options={chartRangeToggleOptions}
                />
            </Stack>
        </Stack>
    );
};

export default MultiAxisAnalysisChart;